// antd
import { Image, Space, theme, Typography } from 'antd'
import { NoProjectsImageIcon } from '../../../assets/icons'
import MultiProjectMediaModal from '../modals/multiProjectMediaModal'
import { useState } from 'react'

// styles
import tabStyles from '../profileTabContent.module.css'

function ProjectsSummaryContent({ contentData }) {
    const { Title, Text } = Typography

    const { useToken } = theme
    const { token } = useToken()

    const [viewMediaProject, setViewMediaProject] = useState({
        open: false,
        project: {},
    })

    return (
        <>
            <div className={tabStyles.summaryGrid}>
                {contentData.map((projectData, index) => {
                    const startDate =
                        projectData?.start !== null
                            ? new Date(projectData?.start)
                            : null
                    const endDate =
                        projectData?.end !== null
                            ? new Date(projectData?.end)
                            : null
                    return (
                        <div
                            className={tabStyles.mediaCard}
                            key={
                                projectData?._id ||
                                projectData?.projectName ||
                                index
                            }
                        >
                            {projectData?.media?.length > 0 ? (
                                <Image
                                    src={projectData?.media[0]}
                                    className={`${tabStyles.mediaThumb} ${tabStyles.mediaThumbContain}`}
                                    preview={false}
                                    onClick={() => {
                                        setViewMediaProject({
                                            open: true,
                                            project: projectData,
                                        })
                                    }}
                                />
                            ) : (
                                <div
                                    className={tabStyles.mediaThumb}
                                    style={{
                                        backgroundColor:
                                            token.colorPalette.textColor
                                                .tertiary,
                                        opacity: 0.4,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '35px',
                                            height: '35px',
                                        }}
                                    >
                                        <NoProjectsImageIcon />
                                    </div>
                                </div>
                            )}
                            <div className={tabStyles.mediaBody}>
                                <Space>
                                    {projectData?.projectName && (
                                        <Title
                                            className={`${tabStyles.mediaTitle} titleSub`}
                                        >
                                            {projectData?.projectName}
                                        </Title>
                                    )}
                                    <Text className="titleLight">
                                        {!projectData?.isCompleted &&
                                            `(Draft)`}
                                    </Text>
                                </Space>
                                <Space>
                                    {startDate !== null && (
                                        <Text
                                            style={{
                                                fontSize: token.fontSizeLG,
                                            }}
                                            className={'titleLight'}
                                        >
                                            {startDate.toLocaleString(
                                                'default',
                                                {
                                                    year: 'numeric',
                                                    month: 'long',
                                                }
                                            )}
                                        </Text>
                                    )}
                                    {startDate !== null &&
                                        (projectData?.currentWorking ||
                                            endDate !== null) &&
                                        '-'}
                                    {(projectData?.currentWorking ||
                                        endDate !== null) && (
                                        <Text
                                            style={{
                                                fontSize: token.fontSizeLG,
                                            }}
                                            className={'titleLight'}
                                        >
                                            {projectData?.currentWorking
                                                ? 'Present'
                                                : new Date(
                                                      endDate
                                                  )?.toLocaleString('default', {
                                                      month: 'long',
                                                      year: 'numeric',
                                                  })}
                                        </Text>
                                    )}
                                </Space>
                            </div>
                        </div>
                    )
                })}
            </div>
            <MultiProjectMediaModal
                projectData={viewMediaProject?.project}
                open={viewMediaProject?.open}
                onClose={() => {
                    setViewMediaProject({
                        open: false,
                        project: {},
                    })
                }}
            />
        </>
    )
}

export default ProjectsSummaryContent
